






import Vue from "vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Intervention } from "../../models/Intervention";
import { EmployeApi } from "../../api/EmployeApi";
import { DemandePinApi } from "../../api/DemandePinApi";
import moment from "moment";

const REFRESH_INTERVAL = 5 * 60 * 1000;

// État partagé par toutes les instances : la barre latérale monte un badge
// par entrée de menu (une cinquantaine), chacune lançait son propre timer et
// ses propres requêtes. Un seul timer, une requête par type d'alerte.
const shared = {
    state: Vue.observable({ counts: {} as Record<string, number> }),
    registrations: {} as Record<string, number>,
    timer: null as any,
    interventionApi: new InterventionApi(),
    employeApi: new EmployeApi(),
    demandePinApi: new DemandePinApi(),
};

function isRegistered(sref: string): boolean {
    return (shared.registrations[sref] || 0) > 0;
}

function refreshCounts() {
    if (isRegistered("app.intervention_dashboard")) {
        shared.interventionApi
            .getAlerts(Intervention.EAlertType.OfflineUsers, true)
            .then(function (res) {
                Vue.set(shared.state.counts, "app.intervention_dashboard", res);
            });
    }
    if (isRegistered("app.facturation_dashboard")) {
        shared.interventionApi
            .getAlerts(Intervention.EAlertType.LateFacturations, true)
            .then(function (res) {
                Vue.set(shared.state.counts, "app.facturation_dashboard", res);
            });
    }
    if (
        isRegistered("app.absence_notifications") ||
        isRegistered("#app.notifications")
    ) {
        shared.employeApi
            .getAbsencesAlerts({
                max_date: moment().add(1, "week").format("YYYY-MM-DD"),
            })
            .then(function (res) {
                Vue.set(shared.state.counts, "app.absence_notifications", res);
                Vue.set(shared.state.counts, "#app.notifications", res);
            });
    }
    // Demandes de Code PIN : sur Clés & accès et sur son parent Matériel.
    // Matériel seul (rôle RH, sans accès bureau) n'interroge pas la route.
    if (isRegistered("app.cles_acces")) {
        shared.demandePinApi.getCount().then(function (res) {
            Vue.set(shared.state.counts, "app.cles_acces", res);
            Vue.set(shared.state.counts, "#app.materiel", res);
        });
    }
}

const RELEVANT_SREFS = [
    "app.intervention_dashboard",
    "app.facturation_dashboard",
    "app.absence_notifications",
    "#app.notifications",
    "app.cles_acces",
    "#app.materiel",
];

// Les instances du menu s'enregistrent toutes au même tick : un seul
// rafraîchissement coalescé, pas un par entrée de menu.
let refreshScheduled = false;
function scheduleRefresh() {
    if (refreshScheduled) {
        return;
    }
    refreshScheduled = true;
    setTimeout(function () {
        refreshScheduled = false;
        refreshCounts();
    }, 50);
}

function register(sref: string) {
    shared.registrations[sref] = (shared.registrations[sref] || 0) + 1;
    if (!shared.timer) {
        shared.timer = setInterval(refreshCounts, REFRESH_INTERVAL);
    }
    if (
        RELEVANT_SREFS.indexOf(sref) !== -1 &&
        shared.registrations[sref] === 1
    ) {
        scheduleRefresh();
    }
}

function unregister(sref: string) {
    shared.registrations[sref] = Math.max(
        0,
        (shared.registrations[sref] || 0) - 1
    );
    const active = Object.keys(shared.registrations).some(isRegistered);
    if (!active && shared.timer) {
        clearInterval(shared.timer);
        shared.timer = null;
    }
}

export default {
    name: "AlertCount",
    props: {
        sref: String,
    },
    data() {
        return {
            shared: shared.state,
        };
    },
    computed: {
        count(): number {
            return this.shared.counts[this.sref] || 0;
        },
    },
    created() {
        register(this.sref);
    },
    destroyed() {
        unregister(this.sref);
    },
};
